module.exports = __webpack_public_path__ + "img/boticario_revendedor.77a6c364.png";